 <template>
  <div>
    <common-list
      ref="list"
      url="WeighingScrap/GetList"
      @currentrow="handlerCurrentRow"
    >
      <!-- 条件区域 -->
      <template v-slot:filter="{ filter }">
        <el-col :span="6">
          <el-form-item label="物料编号" prop="WarehouseName">
            <el-input
              v-model.trim="filter.WarehouseName"
              placeholder="物料编号"
              clearable
            ></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item label="物料类型" prop="WarehouseType">
            <RemoteSelect
              v-model="filter.WarehouseType"
              url="DataDic/GetItemsByType?dicType=WareHouseType"
              code="DicCode"
              name="DicName"
            >
            </RemoteSelect>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item label="车架号" prop="WarehouseCode">
            <el-input
              v-model.trim="filter.WarehouseCode"
              placeholder="车架号"
              clearable
            ></el-input>
          </el-form-item>
        </el-col>
      </template>
      <!-- 按钮区域 -->
      <template v-slot:option>
        <el-button
          type="primary"
          icon="el-icon-plus"
          @click="add"
          v-if="auth('AccessoryStorageAdd')"
          >添加</el-button
        >
        <el-button
          type="warning"
          icon="el-icon-edit"
          @click="edit"
          v-if="auth('AccessoryStorageEdit')"
          >编辑</el-button
        >
        <!-- <el-button
            type="danger"
            icon="el-icon-delete"
            @click="deleteItem"
            v-if="auth('WareHouseDelete')"
            >删除</el-button
          > -->
        <el-button
          type="blue"
          icon="el-icon-tickets"
          @click="show"
          v-if="auth('AccessoryStorageShow')"
          >查看</el-button
        >
      </template>
      <!-- 展示区域 -->
      <template v-slot:body>
        <el-table-column
          label="物料编号"
          prop="WarehouseId"
          show-overflow-tooltip
        ></el-table-column>
        <el-table-column
          label="物料名称"
          prop="WarehouseName"
          show-overflow-tooltip
        ></el-table-column>
        <el-table-column
          label="物料种类"
          prop="AccessoryName"
          show-overflow-tooltip
        >
        </el-table-column>
        <el-table-column
          label="重量（kg）"
          prop="Quantity"
          show-overflow-tooltip
        ></el-table-column>
        <el-table-column
          label="操作人"
          prop="Unit"
          show-overflow-tooltip
        ></el-table-column>
        <el-table-column label="称重时间" prop="Weight" show-overflow-tooltip>
        </el-table-column>
      </template>
    </common-list>
    <!-- 弹窗区域 Show -->
    <div>
      <AddEdit :item="itemAddEdit" @success="getData"></AddEdit>
      <Showdialog :item="itemShow"></Showdialog>
    </div>
  </div>
</template>
  
  <script>
import AddEdit from "./AddEdit";
import Showdialog from "./Show";
export default {
  components: {
    AddEdit,
    Showdialog,
  },
  data() {
    return {
      itemAddEdit: {},
      itemShow: {},
      showitem: [],
    };
  },
  computed: {},
  mounted() {},
  methods: {
    getData() {
      this.$refs.list.getTableData();
    },
    add() {
      this.itemAddEdit = {};
    },
    edit() {
      if (!this.hasCurrentRow()) {
        return;
      }
      this.itemAddEdit = { EntryId: this.currentrow.EntryId };
    },
    deleteItem() {
      if (!this.hasCurrentRow()) {
        return;
      }
      this.$confirm(
        `将删除编号为【${this.currentrow.EntyId}】的仓库信息, 是否继续?`,
        "提示信息",
        {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          cancelButtonClass: "el-button--canale",
          type: "warning",
        }
      )
        .then(() => {
          this.$delete("WareHouse/Delete", {
            WarehouseId: this.currentrow.WarehouseId,
          }).then(() => {
            this.$message.success("删除成功");
            this.$refs.list.getTableData();
          });
        })
        .catch(() => {});
    },
    show() {
      if (!this.hasCurrentRow()) {
        return;
      }
      this.itemShow = { EntryId: this.currentrow.EntryId };
    },
  },
};
</script>
  
  <style>
</style>